import "./customization/registration";

import { Reducer } from "redux";

import { ApplicationStatefulModule } from "@multiweb/types/react";
import { NAME } from "./constants";
import { reducer } from "./reducers";
import { saga } from "./saga";
import { DataSourceMapState } from "./types";

export {
    createAddRootNodes,
    createCheckAllRecordsAction,
    createDeleteDataSourceAction,
    createDeselectAllRecordsAction,
    createExecuteWorkflowAction,
    createInitDataSourceAction,
    createLoadDataAction,
    createLoadWorkflowRequestAction,
    createRefreshAction,
    createSelectNextRecord,
    createSelectPreviousRecord,
    createSelectRecordAction,
    createSelectRecordsAction,
    createSetDatasourceMultiselectModeAction,
    createSetDisableLoadingAction,
    createSetHasDetailFormAction,
    createSetLastSelectedRecordIdAction,
    createSetOrderByAction,
    createToggleCheckAllRecordsAction,
    createToggleCheckOnSelectedRecordsAction,
    createToggleOrderByAction,
    createToggleSelectedRecordCheckAction,
    createUncheckAllRecordsAction,
    createUpdateFulltextDataSourceConditionAction,
    createUpdateMasterFrameDataSourceConditionAction,
    createUpdateRecordActionsAction,
    createUpdateRecordActionsSuccessAction,
} from "./actions";
export {
    LOAD_DATA,
    REFRESH_DATA,
} from "./constants";
export { createFetchActionsLocalizationsKey, createFetchAttributesLocalizationsKey } from "./constants";
export {
    createGetAttributeNameIndex,
    createGetAttributeNames,
    createGetAttributeOrderBySelector,
    createGetBackgroundAttributeColor,
    createGetCheckedRecordsIds,
    createGetUncheckedRecordsIds,
    createIsAtLeastOneRecordChecked,
    getActionById,
    getActionExtendedProperties,
    getActionIconCode,
    getActionLocKey,
    getActions,
    getActionVisibility,
    getAttributeInfoByName,
    getAttributesInfo,
    getAttributeTypeByAttributeName,
    getBackgroundAttributeName,
    getCheckedRecords,
    getConditionParams,
    getConfig,
    getConfigAttributeByName,
    getConfigAttributeDisplayFormat,
    getConfigAttributeNames,
    getConfigAttributes,
    getDataSourceInstance,
    getFetchingCount,
    getFetchingState,
    getFulltextCondition,
    getFulltextSearchString,
    getIsRecordLoaded,
    getLoadingCondition,
    getMultiselectMode,
    getObjectName,
    getOrderBy,
    getOriginalAttributeName,
    getRecordActionsIds,
    getRecordById,
    getRecordIdKey,
    getRecords,
    getRecordsIds,
    getRecordValueById,
    getSelectedRecords,
    getStartIndex,
    getWorkflowActions,
    hasDetailForm,
    hasNextItems,
    hasWorkflow,
    isCheckedAll,
    isEmpty,
    isFetching,
    isFulltextConditionActive,
    isRecordChecked,
    isRecordSelected,
    isWorkflowLoading,
} from "./selectors";
export {
    ActionSelectorParams,
    AttributeSelectorParams,
    CustomMethodDataType,
    ICheckAllRecordsAction,
    IDataSourceAttribute,
    IDataSourceConditions,
    IDataSourceConfig,
    IDataSourceInitConfig,
    IDataSourceState,
    IRefreshDataSuccessAction,
    ISetDatasourceMultiselectModeAction,
    IToggleCheckOnSelectedRecordsAction,
    IToggleSelectedRecordCheckAction,
    IUncheckAllRecordsAction,
    RecordAttributeSelectorParams,
} from "./types";
export { getRecordId, toggleOrderType } from "./utils";

export const dataSourceModule: ApplicationStatefulModule<typeof NAME, Reducer<DataSourceMapState>> = {
    NAME,
    reducer,
    saga,
};
